export default __webpack_public_path__ + "static/2-south-island-label-cfe9d0150140b13c16d87a0b050e2336.svg";